/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_AnalyticsInputs */

const en_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const de_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysen`)
};

const fr_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const es_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis`)
};

const it_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi`)
};

const nl_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const pl_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizy`)
};

const fi_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikka`)
};

const da_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

const sv_settings_feature_analytics = /** @type {(inputs: Settings_Feature_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Settings_Feature_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_analytics = /** @type {((inputs?: Settings_Feature_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_analytics(inputs)
	if (locale === "fr") return fr_settings_feature_analytics(inputs)
	if (locale === "es") return es_settings_feature_analytics(inputs)
	if (locale === "it") return it_settings_feature_analytics(inputs)
	if (locale === "nl") return nl_settings_feature_analytics(inputs)
	if (locale === "pl") return pl_settings_feature_analytics(inputs)
	if (locale === "fi") return fi_settings_feature_analytics(inputs)
	if (locale === "da") return da_settings_feature_analytics(inputs)
	if (locale === "sv") return sv_settings_feature_analytics(inputs)
	return en_settings_feature_analytics(inputs)
});